import {
  createAction,
  createActionGroup,
  emptyProps,
  props
} from '@ngrx/store';
import { AuthTokenRES, BffUserRES } from '@smarsh-cyber/shared/api';
import { FetchActionKeys } from '@smarsh-cyber/shared/constants';
import {
  AppInit,
  AuthToken,
  ErrorModel,
  FactorsModel,
  UserDetail
} from '@smarsh-cyber/shared/models';

export const refreshToken = createAction('[App] Refresh Token');

export const refreshTokenSuccess = createAction(
  '[App] Refresh Token Success',
  props<{ token: AuthToken }>()
);

export const refreshTokenFailure = createAction('[App] Refresh Token Failure');

export const setPortalDetails = createAction(
  '[App] Set Portal Details',
  props<{ portalName: string; portalUrl: string }>()
);

export const appInit = createAction(
  '[App] Load Init',
  props<{ portalName: string; code: string; portalUrl: string }>()
);

export const appLoadSuccess = createAction(
  '[App] Load Success',
  props<{ appInit: AppInit }>()
);

export const appLoadFailure = createAction(
  '[App] Load Failure',
  props<{ error: ErrorModel; showError: boolean }>()
);

export const factorsActions = createActionGroup({
  source: '[APP] Factors',
  events: {
    [FetchActionKeys.FETCH]: emptyProps(),
    [FetchActionKeys.FETCH_SUCCESS]: props<{ data: FactorsModel }>(),
    [FetchActionKeys.FETCH_FAILURE]: emptyProps()
  }
});

export const impersonate = createAction(
  '[App] impersonate',
  props<{
    impersonate: boolean;
    userToBeImpersonated: UserDetail | null;
    userWithoutPermission?: BffUserRES; //this need to fetch permission and translate to UserDetail,
    navigateToDefault?: boolean; //To redirect to default page
  }>()
);

export const ngpInit = createAction(
  '[App] Ngp Init',
  props<{ portalName: string; portalUrl: string; token: AuthTokenRES }>()
);

export const ngpLogout = createAction(
  '[App] Ngp Logout',
  props<{ redirectAfterLogout?: boolean }>()
);
